<template>
  <div class="boxxza">

      <div class="system">
          <div class="returnn">
              <img src="../../../static/img2/fanhui2.png" alt="">
              <span @click="goBack" style="cursor:pointer;">返回</span>
          </div>
          <div class="setting">
              <img class="qian" src="../../../static/img2/11qian.png" alt="">
              <span class="medical_name">{{ course.name }}</span>
              <div class="mapBox">
                  <div id="mapCodeID" @click="enlarge" style="cursor:pointer;">
                      <img v-show="defaultt" :src="imgurl+course.thum" class="imgitem" alt />
                      <img v-if="showInfo.type == 'image'" :src="showInfo.path" class="imgitem" alt />
                      <video v-else class="video" id="video01" controlslist="nodownload noremoteplayback"
                          oncontextmenu="return false" :src="showInfo.path" autoplay="autoplay" alt=""></video>
                  </div>

              </div>

              <div  :class="studyasdov" @mouseenter='enterHandler' @mouseleave='leaveHandler'>
                  <div class="label11">
                      <span>系统简介：</span>
                      <div v-html="course.introduce">

                      </div>

                  </div>
                  <div class="label22">
                        <span>标签内容：</span>
                        <div class="tag_content">{{ course.category.parent_id === 2 ? '口腔类' : '临床类' }}</div>
                        <div class="tag_content2">{{ course.name }}</div>
                    </div>
                    <div class="label33" >
                        <span>此系统内包含：</span>
                        <div class='lacbels' >
                          <div class="tag_content2" v-for="(item,id) in course.childrens" :key="id">{{ item.name }}
                          </div>
                      </div>

                    </div>

              </div>
          </div>

      </div>


        <div class="curelist" style="cursor:pointer;"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="imglist" v-for="(practice, id) in course.childrens" :key="id" @click="courseHandler(practice.id, practice)">
          <img :src="imgurl+practice.thum" style="width:100%" alt="">
          <span class="sp1">{{ practice.name }}</span>
          <span class="sp2"><img src="../../../static/img2/time.png" alt=""></span>
          <span class="sp3">{{ practice.change_time}} </span>
          <span class="sp4"><img src="../../../static/img2/rs.png" alt=""></span>
          <span class="sp5">{{  computeCount(practice.user_count)  }}</span>
          <span class="sp6"><img src="../../../static/img2/xx.png" alt=""><img src="../../../static/img2/xx.png"
              alt=""><img src="../../../static/img2/xx.png" alt=""><img src="../../../static/img2/xx.png" alt=""><img
              src="../../../static/img2/xx.png" alt=""></span>
          <div class="botomsp"></div>
        </div>


      </div>
  </div>
</template>

<script>

export default {
  name: "CourseDetail",
  data() {
      return {
          tab: 1,
          courseType: ["在线训练", "模型", "智能设备"],
          course: {
              category: ""
          },
          xqlist: '',
          course:'',
          studyasdov:{
            aa:true,
          bb:false,
          },
          childrensl:'',
          xqlist2: '',
          imgurl:'http://www.univrlab.com/',
          childpractice:'',
          show: false,
          FullScreen: false,
          imgUrlList: '',
          ys1: true,
          itemimage: '',
          ys2: '',
          ys3: '',
          ys4: '',

          activeName: "first",
          value: 5.0,
          centerDialogVisible: false,
          iframeSrc: "",
          count: '',
          code: '',
          defaultt: true,
          arrows: false,
          titles: '',
          titles2: '',
          isdisabled: false,
          schoolInfo: this.$store.getters.getUserInfo.school,
          imgchenck: '',
          imgActiveIndex: '', // 当前移动图片的索引值
          imgDistance: 0, // 移动的距离
          allDistance: 0, // 总移动距离

          showInfo: {
              type: ''
          }
      };
  },
  created() {
   this.gettingData()

  },
  computed: {

      imgStyle() {
          // console.log('this.imgDistance');
          // console.log(this.imgDistance);
          // console.log('this.imgDistance');

          return {
              transform: `translate3d(${this.imgDistance}px, 0, 0)` // 计算移动的距离(x,y,z)
          }
      }
  },
  methods: {
    courseHandler(courseId) {

        this.$router.push({
        path: `/courses/${courseId}/details-introduce`,
      })


    },
    gettingData() {
        var querychildrens = this.$route.query.childrens
        this.childrensl = querychildrens
        var practrens = this.$route.query.practice
        this.childpractice =practrens
        console.log( this.childrensl)
        console.log( this.childpractice)

      },
      computeCount(value) {
      //console.log(value);
      if (!value) return 0
      //  console.log(value.length)
      return value >= 10000 ? `${String(value).substring(0, 1)}万+` : value
    },
    enterHandler(){
      this.studyasdov.aa = false
      this.studyasdov.bb = true
    },
    leaveHandler(){
      this.studyasdov.aa = true
      this.studyasdov.bb = false
    },
      enlarge() {
            // let element = document.documentElement;//全屏放大
            let element = document.getElementById("mapCodeID"); //需要全屏容器的id
            // 浏览器兼容
            if (this.FullScreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    element.msRequestFullscreen();
                }
            }
            this.FullScreen = !this.FullScreen;
        },
      color: function (id) {
          if (this.count === id) {
              return 'imgckeck';
          }
      },
      goBack() {
        this.$router.go(-1);
      },
      Collection_classes(id) {
          var id = id;
          this.$http
              .ctionclass({ id: this.$route.params.detailId, learn_id: id })
              .then(res => {
                  if (res.code === 0) {

                  }
                  this.getCourse();
              })

      },

      // 获取课程详情
      getCourse() {
          var user_id = this.$store.getters.getUserInfo.id;
          this.$http
              .courseAllList({ id: this.$route.query.courseId, user_id: user_id })
              .then(res => {
                  if (res.code !== 0) {
                       this.course = res.data.learn[0];
                      console.log(this.course)
                      return
                      let xqlist = res.data.learn[0].details[0].content
                      this.xqlist2 = res.data.learn[0].details[1].content
                      this.titles = res.data.learn[0].details[0].title
                      this.titles2 = res.data.learn[0].details[1].title
                      this.xqlist = xqlist
                      let imgUrlList = res.data.learn[0].files
                      this.imgUrlList = imgUrlList
                      console.log(imgUrlList)
                      if (this.imgUrlList != '') {
                          this.arrows = true
                      }
                      // this.showInfo = this.course.files[0]
                  } else {
                      this.$message.error(res.message);
                  }
              });
      },
  },
  mounted() {
      this.getCourse();
  }
};
</script>


<style lang="less" >
@media screen and (max-width: 768px) {
  .video {
      width: 661px;
      height: 372px;
      position: absolute;
      top: 75px;
      left: 45px;
  }

  .boxxza {
      width: 100%;
      height: 100%;
      overflow: hidden;
      background-color: #212129;

      .imgckeck {
          border: 2px solid #07f4ff;
          background-color: rgba(25, 24, 24, 0.9);
          z-index: 10000;
      }

      .sousuo {
          height: 78px;
          width: 100%;
          position: relative;

          input {
              width: 400px;
              height: 35px;
              border: 0;
              border-radius: 25px;
              position: absolute;
              top: 20px;
              left: 708px;
              outline: none;
          }

          button {
              width: 115px;
              height: 35px;
              background-color: #1eb9ef;
              border: 0;
              border-radius: 25px;
              color: #fff;
              position: absolute;
              top: 21px;
              left: 1060px;
              font-size: 16px;
              padding-left: 30px;
          }

          img {
              position: absolute;
              top: 30px;
              left: 1085px;
              z-index: 1000;
          }
      }

      .system {
          width: 100%;
          height: 295rem;

          .returnn {
              width: 100%;
              height: 75px;
              margin: auto;
              position: relative;

              img {
                  position: absolute;
                  top: 8rem;
                  left: 6rem;
              }

              span {
                  position: absolute;
                  top: 6.8rem;
                  left: 12rem;
                  font-size: 16px;
                  color: #1eb9ee;
              }
          }

          .setting {
              width: 100%;
              //  height: 100%;
              background-color: #282931;
              margin: auto;
              position: relative;

              .qian {
                  position: absolute;
                  top: 31px;
                  left: 46px;
              }
          }

          .medical_name {
              font-size: 14px;
              color: #fff;
              position: absolute;
              top: 8.5rem;
              left: 64px;
              z-index: 10000;
          }

          .score {
              width: 176px;
              height: 25px;
              position: absolute;
              top: 105rem;
              left: 10rem;

              span {
                  font-size: 24px;
                  color: #ffb628;
              }

              img {
                  padding-left: 5px;
              }
          }

          .collect111 {
              position: absolute;
              top: 105rem;
              right: 7rem;
          }

          .studyasd {
              width: 115rem;
              min-height: 128rem;
            overflow: auto;
              background-color: #36373f;
              position: absolute;
              top: 120rem;
              right: 3rem;

              .label11 {
                  width: 383px;
                  margin: auto;
                  border-bottom: 1px solid #5a5b66;
                  div{
                    margin-left: 30px;
                    margin-top: 60px;
                    margin-bottom: 10px;
                    color: #fff;
                  }
                  span {
                      position: absolute;
                      top: 36px;
                      left: 45px;
                      font-size: 12px;
                      letter-spacing:1.5px;
                      color: #fff;
                  }

              }
              .label22 {
                  width: 383px;
                  height: 117px;
                  margin: auto;
                  position: relative;
                  border-bottom: 1px solid #5a5b66;

                  span {
                      position: absolute;
                      top: 30px;
                      left: 25px;
                      font-size: 12px;
                      color: #fff;
                  }

                  .tag_content {
                      width: 74px;
                      height: 27px;
                      background-color: #3c4853;
                      font-size: 12px;
                      color: #6edbff;
                      line-height: 27px;
                      text-align: center;
                      border-radius: 25px;
                      position: absolute;
                      top: 66px;
                      left: 25px;
                  }

                  .tag_content2 {
                      //  width: 109px;
                      max-width: 220px;
                      height: 27px;
                      background-color: #3c4853;
                      font-size: 12px;
                      color: #6edbff;
                      line-height: 27px;
                      text-align: center;
                      border-radius: 25px;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                      position: absolute;
                      top: 66px;
                      left: 133px;
                      padding: 0 18px 0 18px;
                  }
              }

              .label33 {
                  width: 383px;
                  margin: auto;
                  position: relative;
                  span {
                      position: absolute;
                      top: 10px;
                      left: 25px;
                      font-size: 12px;
                      letter-spacing:1.5px;
                      color: #fff;
                  }
                  .lacbels{
                      width: 400px;
                      position: absolute;
                      top: 18px;
                      right: 0px;
                  .tag_content2 {
                      //  width: 109px;
                      max-width: 160px;
                      height: 27px;
                      background-color: #3c4853;
                      font-size: 12px;
                      color: #6edbff;
                      line-height: 27px;
                      margin-top: 20px;
                      text-align: center;
                      border-radius: 25px;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                      margin-left: 37px;
                      padding: 0 18px 0 18px;
                  }
                  }

              }

              .particulars {
                  width: 383px;
                  height: 140px;
                  margin: auto;
                  position: relative;

                  .genre1 {
                      position: absolute;
                      top: 29px;
                      left: 14px;
                      color: #ffffff;
                      font-size: 12px;
                  }

                  .genre2 {
                      position: absolute;
                      top: 63px;
                      left: 14px;
                      color: #ffffff;
                      font-size: 12px;
                  }

                  .genre3 {
                      position: absolute;
                      top: 97px;
                      left: 14px;
                      color: #ffffff;
                      font-size: 12px;
                  }

                  .init {
                      display: none;
                      position: absolute;
                      top: 50rem;
                      left: 35rem;
                  }

                  .initt {
                      position: absolute;
                      top: 50rem;
                      left: 35rem;
                  }

                  .initiate {
                      display: none;
                      position: absolute;
                      top: 52.5rem;
                      left: 44.5rem;
                      font-size: 18px;
                      color: #fff;
                  }

                  .initiatee {
                      position: absolute;
                      top: 52.5rem;
                      left: 45rem;
                      font-size: 18px;
                      color: #fff;
                  }
              }
          }

      }
      .curelist {
      width: 90%;
      height: 100%;
      margin: 2rem auto;
      overflow: hidden;

      .imglist {
        width: 289px;
        height: 200px;
        background-color: #111217;
        margin: 0 auto 6rem;
        position: relative;

        .botomsp {
          height: 41px;
          width: 100%;
          background-color: #111217;
          position: absolute;
          bottom: 0;
          left: 0;
        }

        .sp1 {
          position: absolute;
          top: 131px;
          left: 0;
          color: #ffffff;
          font-size: 12px;
          width: 100%;
          height: 28px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          display: block;
          line-height: 28px;
          text-align: center;
          background: rgba(0, 0, 0, 0.8);
        }

        .sp2 {
          position: absolute;
          top: 170px;
          left: 22px;
          color: #ffffff;
          z-index: 10000;
        }

        .sp3 {
          position: absolute;
          top: 172px;
          left: 40px;
          color: #ffffff;
          font-size: 12px;
          z-index: 10000;
        }

        .sp4 {
          position: absolute;
          top: 172px;
          left: 118px;
          color: #ffffff;
          z-index: 10000;
        }

        .sp5 {
          position: absolute;
          top: 172px;
          left: 139px;
          color: #ffffff;
          font-size: 12px;
          z-index: 10000;
        }

        .sp6 {
          position: absolute;
          top: 170px;
          left: 189px;
          color: #ffffff;
          z-index: 10000;

          img {
            margin-left: 4px;
          }
        }
      }
    }
      .select_image {
          width: 100%;
          height: 100%;
          display: flex;
          flex-wrap: wrap;
          position: relative;
          top: -50rem;

          .rightx {

              display: none;
          }

          .leftx {

              display: none;
          }

          .Img_ul {
              height: 100%;
              width: 98%;
          }

          .Img_li {
              width: 41rem;
              height: 21rem;
              float: left;
              margin: 0 5rem 5rem 12rem;
              cursor: pointer;

              img {
                  width: 40rem;
                  height: 20rem;
              }
          }

          .img_activeBorder {
              border: 2px solid #07f4ff;


          }

      }

      .bottomxq {
          width: 90%;
          margin: auto;
          background-color: #212229;
          border: 0;
          position: relative;
          top: -40rem;
          color: rgb(252, 250, 250);

          //   border-top: 1px solid #6edbff;
          .sytematic1 {
              width: 100rem;
          }

          .sytematic2 {
              width: 100rem;
          }

          .systematic {
              height: 44px;
              width: 100%;
              background-color: #282931;

              .type {
                  border: 1px solid #6edbff;
                  background-color: #212229;
                  z-index: 1000;
                  color: #6edbff;
                  border-bottom: 1px solid #212229;
                  cursor: pointer;
              }

              .henggang {
                  height: 20px;
                  border-bottom: 1px solid #6edbff;
                  padding-bottom: 10px
              }

              div {
                  width: 106px;
                  height: 100%;
                  float: left;
                  line-height: 44px;
                  text-align: center;
                  font-size: 16px;
                  color: #64656a;
                  margin-top: -1px;
                  cursor: pointer;

              }
          }

          .systematiclist {
              width: 100%;
              border: 1px solid #6edbff;

          }

      }

      .mapBox {
          position: relative;
      }

      #mapCodeID {
          width: 100rem;
          height: 80rem;
          position: absolute;
          top: 75px;
          left: 10rem;
      }

      #mapCodeID .imgitem {
          width: 100%;
          height: 100%;
      }

      .mapBox .iconBox {
          cursor: pointer;
          position: absolute;
          width: 30px;
          height: 30px;
          top: 90px;
          left: 650px;
      }

      .mapBox .iconBox img {
          position: absolute;
          top: 5px;
          left: 5px;
      }

  }
}

@media screen and (min-width: 768px) {
  .video {
      width: 661px;
      height: 372px;
      position: absolute;
      top: 75px;
      left: 45px;
  }

  .boxxza {
      width: 100%;
      height: 100%;
      overflow: hidden;
      background-color: #212129;

      .imgckeck {
          border: 2px solid #07f4ff;
          background-color: rgba(25, 24, 24, 0.9);
          z-index: 10000;
      }

      .sousuo {
          height: 78px;
          width: 100%;
          position: relative;

          input {
              width: 400px;
              height: 35px;
              border: 0;
              border-radius: 25px;
              position: absolute;
              top: 20px;
              left: 708px;
              outline: none;
          }

          button {
              width: 115px;
              height: 35px;
              background-color: #1eb9ef;
              border: 0;
              border-radius: 25px;
              color: #fff;
              position: absolute;
              top: 21px;
              left: 1060px;
              font-size: 16px;
              padding-left: 30px;
          }

          img {
              position: absolute;
              top: 30px;
              left: 1085px;
              z-index: 1000;
          }
      }

      .system {
          width: 100%;
          height: 585px;
          background-color: #191a20;

          .returnn {
              width: 1219px;
              height: 75px;
              margin: auto;
              position: relative;

              img {
                  position: absolute;
                  top: 30px;
                  left: 0;
              }

              span {
                  position: absolute;
                  top: 25px;
                  left: 30px;
                  font-size: 16px;
                  color: #1eb9ee;
              }
          }

          .setting {
              width: 1219px;
              height: 482px;
              background-color: #282931;
              margin: auto;
              position: relative;

              .qian {
                  position: absolute;
                  top: 31px;
                  left: 46px;
              }
          }

          .medical_name {
              font-size: 24px;
              color: #fff;
              position: absolute;
              top: 23px;
              left: 64px;
          }

          .score {
              width: 176px;
              height: 25px;
              position: absolute;
              top: 79px;
              left: 741px;

              span {
                  font-size: 24px;
                  color: #ffb628;
              }

              img {
                  padding-left: 5px;
              }
          }

          .collect111 {
              position: absolute;
              top: 75px;
              right: 76px;
          }
                    ::-webkit-scrollbar {
                        width: 8px;
                        height: 8px;
                        background: #5c5b5b;   /*可以设置轨道颜色*/
                        padding-right: 2px;
                      }

                      /*滚动条*/
                      ::-webkit-scrollbar-thumb {
                        background: #898a85;
                        border-radius: 10px;
                      }
          .aa {
              width: 424px;
            min-height: 380px;
            overflow: auto;
            overflow: hidden;
              background-color: #36373f;
              position: absolute;
              top: 74px;
              right: 56px;


                  .label11 {
                  width: 383px;
                  margin: auto;
                  border-bottom: 1px solid #5a5b66;
                  div{
                    margin-left: 10px;
                    margin-top: 60px;
                    margin-bottom: 10px;
                    color: #fff;
                  }
                  span {
                      position: absolute;
                      top: 36px;
                      left: 45px;
                      font-size: 12px;
                      letter-spacing:1.5px;
                      color: #fff;
                  }

              }
              .label22 {
                  width: 383px;
                  height: 117px;
                  margin: auto;
                  position: relative;
                  border-bottom: 1px solid #5a5b66;

                  span {
                      position: absolute;
                      top: 30px;
                      left: 25px;
                      font-size: 12px;
                      color: #fff;
                  }

                  .tag_content {
                      width: 74px;
                      height: 27px;
                      background-color: #3c4853;
                      font-size: 12px;
                      color: #6edbff;
                      line-height: 27px;
                      text-align: center;
                      border-radius: 25px;
                      position: absolute;
                      top: 66px;
                      left: 25px;
                  }

                  .tag_content2 {
                      //  width: 109px;
                      max-width: 220px;
                      height: 27px;
                      background-color: #3c4853;
                      font-size: 12px;
                      color: #6edbff;
                      line-height: 27px;
                      text-align: center;
                      border-radius: 25px;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                      position: absolute;
                      top: 66px;
                      left: 133px;
                      padding: 0 18px 0 18px;
                  }
              }

              .label33 {
                  width: 383px;
                  margin: auto;
                  position: relative;
                  span {
                      position: absolute;
                      top: 10px;
                      left: 25px;
                      font-size: 12px;
                      letter-spacing:1.5px;
                      color: #fff;
                  }
                  .lacbels{
                      width: 400px;
                      position: absolute;
                      top: 18px;
                      right: 0px;
                  .tag_content2 {
                      //  width: 109px;
                      max-width: 160px;
                      height: 27px;
                      background-color: #3c4853;
                      font-size: 12px;
                      color: #6edbff;
                      line-height: 27px;
                      margin-top: 20px;
                      text-align: center;
                      border-radius: 25px;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                      margin-left: 37px;
                      padding: 0 18px 0 18px;
                  }
                  }

              }

              .particulars {
                  width: 383px;
                  height: 140px;
                  margin: auto;
                  position: relative;

                  .genre1 {
                      position: absolute;
                      top: 29px;
                      letter-spacing:1.5px;
                      left: 14px;
                      color: #ffffff;
                      font-size: 12px;
                  }

                  .genre2 {
                      position: absolute;
                      top: 63px;
                      left: 14px;
                      color: #ffffff;
                      font-size: 12px;
                  }

                  .genre3 {
                      position: absolute;
                      top: 97px;
                      left: 14px;
                      color: #ffffff;
                      font-size: 12px;
                  }

                  .init {
                      position: absolute;
                      top: 154px;
                      left: 121px;
                  }

                  .initt {
                      display: none;
                      position: absolute;
                      top: 154px;
                      left: 121px;
                  }

                  .initiate {
                      position: absolute;
                      top: 162px;
                      left: 155px;
                      font-size: 18px;
                      color: #fff;
                  }

                  .initiatee {
                      display: none;
                      position: absolute;
                      top: 162px;
                      left: 155px;
                      font-size: 18px;
                      color: #fff;
                  }
              }
          }
          .bb {
              width: 424px;
            min-height: 380px;
            overflow: auto;
              background-color: #36373f;
              position: absolute;
              top: 74px;
              right: 56px;


                  .label11 {
                  width: 383px;
                  margin: auto;
                  border-bottom: 1px solid #5a5b66;
                  div{
                    margin-left: 10px;
                    margin-top: 60px;
                    margin-bottom: 10px;
                    color: #fff;
                  }
                  span {
                      position: absolute;
                      top: 36px;
                      left: 45px;
                      font-size: 12px;
                      letter-spacing:1.5px;
                      color: #fff;
                  }

              }
              .label22 {
                  width: 383px;
                  height: 117px;
                  margin: auto;
                  position: relative;
                  border-bottom: 1px solid #5a5b66;

                  span {
                      position: absolute;
                      top: 30px;
                      left: 25px;
                      font-size: 12px;
                      color: #fff;
                  }

                  .tag_content {
                      width: 74px;
                      height: 27px;
                      background-color: #3c4853;
                      font-size: 12px;
                      color: #6edbff;
                      line-height: 27px;
                      text-align: center;
                      border-radius: 25px;
                      position: absolute;
                      top: 66px;
                      left: 25px;
                  }

                  .tag_content2 {
                      //  width: 109px;
                      max-width: 220px;
                      height: 27px;
                      background-color: #3c4853;
                      font-size: 12px;
                      color: #6edbff;
                      line-height: 27px;
                      text-align: center;
                      border-radius: 25px;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                      position: absolute;
                      top: 66px;
                      left: 133px;
                      padding: 0 18px 0 18px;
                  }
              }

              .label33 {
                  width: 383px;
                  margin: auto;
                  position: relative;
                  span {
                      position: absolute;
                      top: 10px;
                      left: 25px;
                      font-size: 12px;
                      letter-spacing:1.5px;
                      color: #fff;
                  }
                  .lacbels{
                      width: 400px;
                      position: absolute;
                      top: 18px;
                      right: 0px;
                  .tag_content2 {
                      //  width: 109px;
                      max-width: 230px;
                      height: 27px;
                      background-color: #3c4853;
                      font-size: 12px;
                      color: #6edbff;
                      line-height: 27px;
                      margin-top: 20px;
                      text-align: center;
                      border-radius: 25px;
                      margin-left: 37px;
                      padding: 0 18px 0 18px;
                  }
                  }

              }

              .particulars {
                  width: 383px;
                  height: 140px;
                  margin: auto;
                  position: relative;

                  .genre1 {
                      position: absolute;
                      top: 29px;
                      letter-spacing:1.5px;
                      left: 14px;
                      color: #ffffff;
                      font-size: 12px;
                  }

                  .genre2 {
                      position: absolute;
                      top: 63px;
                      left: 14px;
                      color: #ffffff;
                      font-size: 12px;
                  }

                  .genre3 {
                      position: absolute;
                      top: 97px;
                      left: 14px;
                      color: #ffffff;
                      font-size: 12px;
                  }

                  .init {
                      position: absolute;
                      top: 154px;
                      left: 121px;
                  }

                  .initt {
                      display: none;
                      position: absolute;
                      top: 154px;
                      left: 121px;
                  }

                  .initiate {
                      position: absolute;
                      top: 162px;
                      left: 155px;
                      font-size: 18px;
                      color: #fff;
                  }

                  .initiatee {
                      display: none;
                      position: absolute;
                      top: 162px;
                      left: 155px;
                      font-size: 18px;
                      color: #fff;
                  }
              }
          }

      }

      .select_image {
          width: 1219px;
          height: 158px;
          margin: auto;
          position: relative;
          top: -150px;
          left: 0;

          .rightx {
              position: absolute;
              top: 30px;
              left: 0;
          }

          .leftx {
              position: absolute;
              top: 30px;
              right: 0;
          }

          .Img_ul {
              position: relative;
              display: flex;
              left: 45px;
              width: 1155px;
              height: 80px;
              top: 30px;
              overflow: hidden;
              list-style: none;
          }

          .Img_li {
              float: left;
              margin: 0 8px;
              cursor: pointer;

              img {
                  width: 132px;
                  height: 75px;
              }

              video {
                  width: 132px;
                  height: 75px;
              }
          }

          .img_activeBorder {
              border: 2px solid #07f4ff;


          }

      }


          .curelist {
      width: 1250px;
      height: 434px;
      margin: 80px auto;
      padding-right: 10px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      overflow: hidden;

      .imglist {
        width: 289px;
        height: 200px;
        background-color: #111217;
        margin-bottom: 34px;
        position: relative;
        margin-left: 21px;

        .botomsp {
          height: 41px;
          width: 100%;
          background-color: #111217;
          position: absolute;
          bottom: 0;
          left: 0;
        }

        .sp1 {
          position: absolute;
          top: 131px;
          left: 0;
          color: #ffffff;
          font-size: 12px;
          width: 100%;
          height: 28px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          display: block;
          line-height: 28px;
          text-align: center;
          background: rgba(0, 0, 0, 0.8);
        }

        .sp2 {
          position: absolute;
          top: 170px;
          left: 22px;
          color: #ffffff;
          z-index: 10000;
        }

        .sp3 {
          position: absolute;
          top: 172px;
          left: 40px;
          color: #ffffff;
          font-size: 12px;
          z-index: 10000;
        }

        .sp4 {
          position: absolute;
          top: 172px;
          left: 118px;
          color: #ffffff;
          z-index: 10000;
        }

        .sp5 {
          position: absolute;
          top: 172px;
          left: 139px;
          color: #ffffff;
          font-size: 12px;
          z-index: 10000;
        }

        .sp6 {
          position: absolute;
          top: 170px;
          left: 189px;
          color: #ffffff;
          z-index: 10000;

          img {
            margin-left: 4px;
          }
        }
      }

          //   border-top: 1px solid #6edbff;
          .sytematic1 {
              width: 1100px;
          }

          .sytematic2 {
              width: 1100px;
          }

          .systematic {
              height: 44px;
              width: 100%;
              background-color: #282931;
              position: relative;

              .type {
                  border: 1px solid #6edbff;
                  background-color: #212229;
                  z-index: 1000;
                  color: #6edbff;
                  border-bottom: 1px solid #212229;
                  cursor: pointer;
              }

              .henggang {
                  height: 20px;
                  border-bottom: 1px solid #6edbff;
                  padding-bottom: 10px
              }

              div {
                  width: 106px;
                  height: 100%;
                  float: left;
                  line-height: 44px;
                  text-align: center;
                  font-size: 16px;
                  color: #64656a;
                  margin-top: -1px;
                  cursor: pointer;

              }
          }

          .systematiclist {
              width: 100%;
              border: 1px solid #6edbff;
          }
      }

      .mapBox {
          position: relative;
      }

      #mapCodeID {
          width: 661px;
          height: 372px;
          position: absolute;
          top: 75px;
          left: 45px;
      }

      #mapCodeID .imgitem {
          width: 100%;
          height: 100%;
      }

      .mapBox .iconBox {
          cursor: pointer;
          position: absolute;
          width: 30px;
          height: 30px;
          top: 90px;
          left: 650px;
      }

      .mapBox .iconBox img {
          position: absolute;
          top: 5px;
          left: 5px;
      }

  }
}
</style>




// WEBPACK FOOTER //
// src/components/User/Channel.vue